/**
 * Normalises matchup result payloads into MatchupStatsHero props.
 */
export function getMatchupStatsProps(results, resultsMode, currentPlayerId, getPlayerDisplayName) {
  if (!results) return null;

  if (resultsMode === 'teammate-only') {
    return {
      variant: 'teammate',
      wins: results.wins ?? 0,
      losses: results.losses ?? 0,
      totalGames: results.totalGames ?? 0,
      winRate: results.winRate,
    };
  }

  if (resultsMode === 'individual') {
    const isPlayer1 = results.player1Id === currentPlayerId;
    return {
      variant: 'individual',
      wins: isPlayer1 ? results.player1Wins ?? 0 : results.player2Wins ?? 0,
      losses: isPlayer1 ? results.player2Wins ?? 0 : results.player1Wins ?? 0,
      totalGames: results.totalGames ?? 0,
      winRate: isPlayer1 ? results.player1WinRate : results.player2WinRate,
      opponentLabel: results.opponent ? getPlayerDisplayName(results.opponent) : undefined,
    };
  }

  const games = results.games ?? [];
  const totalGames = results.totalGames || games.length;
  const wins = results.wins ?? results.team1Wins ?? 0;
  const losses = results.losses ?? results.team2Wins ?? 0;
  const winRate =
    results.winRate != null
      ? results.winRate
      : totalGames > 0
        ? (wins / totalGames) * 100
        : results.team1WinRate ?? 0;

  return {
    variant: 'team',
    wins,
    losses,
    totalGames,
    winRate,
  };
}
